<template>
    <p-modal 
        name='StockAdjustmentModal' 
        ref='stockAdjustmentModal'
        label='Stock Adjustment' 
        size='lg' 
        ok-label='Save'
        @ok='handleModalOk' 
        @hidden='handleModalHidden'>
        <p-input readonly label='Sku' v-model='stockAdjustment.sku' />
        <p-number label='Qty' placeholder='(eg -5, 5 )' v-model='stockAdjustment.qty' input-type='integer' left-align />
        <p-select
            v-model='stockAdjustment.reason'
            dataType='stockAdjustmentReasons'
            :disabled='stockAdjustment.sku === null'
            value-field='text'
            label='Reason'
        />
        <p-text-area
            v-model='stockAdjustment.comment'
            :disabled='stockAdjustment.sku === null'
            label='Comment'
            rules="max:2000"
        />
        <p-checkbox v-if="stockAdjustment.isPackage"
            v-model='stockAdjustment.applyToPackageComponents'
            label='Adjust Component(s) stock on hand?' />        
    </p-modal>
</template>

<script>
import axios from 'axios';
import selectListOptionsDataContext from '@/services/selectListOptions.dataContext.js';

export default {
    name: 'StockAdjustment',
    emits: ['ok'],
    props: {
        adjustmentData: {}
    },
    data() {
        return {
            stockAdjustment: {
                qty: 0,
                sku: 0,
                cost: 0,
                retail: 0,
                reason: 'Count Adjustment',
                comment: null,
                locationId: null,
                isPackage: false,
                applyToPackageComponents: true
            },
            defaultReason: 'Count Adjustment'
        };
    },
    watch: {
        adjustmentData: {
            handler: function() {
                this.stockAdjustment.sku = this.adjustmentData.sku;
                this.stockAdjustment.cost = this.adjustmentData.cost;
                this.stockAdjustment.retail = this.adjustmentData.retail;
                this.stockAdjustment.isPackage = this.adjustmentData.isPackage;
            },
            deep: true
        },
        'stockAdjustment.reason': { 
            handler: function(value) {
                if(!value) {
                    this.stockAdjustment.reason = this.defaultReason;
                }
            }
        }
    },
    methods: {
        async handleModalOk(event) {
            if (this.stockAdjustment.isPackage) {
                event.preventDefault(); // Leave the modal open until we get a response from the user

                const msg = this.stockAdjustment.applyToPackageComponents
                    ? 'This action will change the inventory for this SKU and each component that is in the package. The result will create multiple SKU entries in Stock Ledger and on the Stock Adjustment report. Are you sure you want to continue?'
                    : 'This action will change the inventory for this package SKU only. There will be no impact to component(s)\' stock on hand. The result will create a single SKU entry in Stock Ledger and on the Stock Adjustment report. Are you sure you want to continue?';

                const confirmed = await this.$bvModal.msgBoxConfirm(msg, {
                    title: 'Confirm Adjustment',
                    size: 'md',
                    buttonSize: 'md',
                    okVariant: 'primary',
                    okTitle: 'OK',
                    cancelTitle: 'Cancel',
                    footerClass: 'p-2',
                    centered: true
                });

                if (confirmed) {
                    this.$refs.stockAdjustmentModal.hide(); // User confirmed, hide the modal
                }
                else {
                    return; // Indecisive user, leave the modal open
                }
            }

            // Snapshot before any awaits - handleModalHidden may reset qty to 0 while we're waiting (modal auto-closes for non-package adjustments).
            const stockAdjustment = { ...this.stockAdjustment };

            if (stockAdjustment.sku !== null && stockAdjustment.qty !== 0) {
                stockAdjustment.locationId = await selectListOptionsDataContext.getSelectedLocationIdAsync();
                await axios.post('stockAdjustment/', stockAdjustment);
            }

            this.$emit('ok', stockAdjustment);
        },
        handleModalHidden() {
            this.stockAdjustment.qty = 0;
            this.stockAdjustment.reason = this.defaultReason;
            this.stockAdjustment.comment = null;
            this.stockAdjustment.applyToPackageComponents = true;
        }
    }
};
</script>